import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=fac07c9c&scoped=true&"
import script from "./AddProject.vue?vue&type=script&lang=js&"
export * from "./AddProject.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.vue?vue&type=style&index=0&id=fac07c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac07c9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VForm,VRow})
